import { ReasonCompetitionStep } from '../../Reasons/constants';
import {
  AccountClosureFormExplanationField,
  AccountClosureFormValues,
} from '../../types';

const getFormattedAccountClosureFormValues = (
  formValues: AccountClosureFormValues,
) => {
  const {
    hasLeftForCompetition,
    hasLeftForCompetitionExplanation,
    otherExplanation,
    reasons,
    satisfiedMissingBankingServiceExplanation,
    satisfiedMissingFeatureExplanation,
    satisfiedNoActivityOrTooFewActivityForNowExplanation,
    satisfiedOtherExplanation,
    satisfiedPricingIssueExplanation,
    satisfiedTechnicalIssueExplanation,
    unsatisfiedBadBankingServiceExperienceExplanation,
    unsatisfiedBadSupportExperienceExplanation,
    unsatisfiedMissingBankingServiceExplanation,
    unsatisfiedMissingFeatureExplanation,
    unsatisfiedOtherExplanation,
    unsatisfiedPricingIssueExplanation,
    unsatisfiedTechnicalIssueExplanation,
  } = formValues;

  const leftForCompetition =
    hasLeftForCompetition === ReasonCompetitionStep.Yes;

  const explanationsPayload: Partial<
    Record<AccountClosureFormExplanationField, string>
  > = {};

  if (hasLeftForCompetitionExplanation) {
    explanationsPayload.hasLeftForCompetitionExplanation =
      hasLeftForCompetitionExplanation;
  }

  if (otherExplanation) {
    explanationsPayload.otherExplanation = otherExplanation;
  }

  if (satisfiedMissingBankingServiceExplanation) {
    explanationsPayload.satisfiedMissingBankingServiceExplanation =
      satisfiedMissingBankingServiceExplanation;
  }

  if (satisfiedMissingFeatureExplanation) {
    explanationsPayload.satisfiedMissingFeatureExplanation =
      satisfiedMissingFeatureExplanation;
  }
  if (satisfiedNoActivityOrTooFewActivityForNowExplanation) {
    explanationsPayload.satisfiedNoActivityOrTooFewActivityForNowExplanation =
      satisfiedNoActivityOrTooFewActivityForNowExplanation;
  }

  if (satisfiedOtherExplanation) {
    explanationsPayload.satisfiedOtherExplanation = satisfiedOtherExplanation;
  }

  if (satisfiedPricingIssueExplanation) {
    explanationsPayload.satisfiedPricingIssueExplanation =
      satisfiedPricingIssueExplanation;
  }

  if (satisfiedTechnicalIssueExplanation) {
    explanationsPayload.satisfiedTechnicalIssueExplanation =
      satisfiedTechnicalIssueExplanation;
  }

  if (unsatisfiedBadBankingServiceExperienceExplanation) {
    explanationsPayload.unsatisfiedBadBankingServiceExperienceExplanation =
      unsatisfiedBadBankingServiceExperienceExplanation;
  }

  if (unsatisfiedBadSupportExperienceExplanation) {
    explanationsPayload.unsatisfiedBadSupportExperienceExplanation =
      unsatisfiedBadSupportExperienceExplanation;
  }

  if (unsatisfiedMissingBankingServiceExplanation) {
    explanationsPayload.unsatisfiedMissingBankingServiceExplanation =
      unsatisfiedMissingBankingServiceExplanation;
  }

  if (unsatisfiedMissingFeatureExplanation) {
    explanationsPayload.unsatisfiedMissingFeatureExplanation =
      unsatisfiedMissingFeatureExplanation;
  }

  if (unsatisfiedPricingIssueExplanation) {
    explanationsPayload.unsatisfiedPricingIssueExplanation =
      unsatisfiedPricingIssueExplanation;
  }

  if (unsatisfiedTechnicalIssueExplanation) {
    explanationsPayload.unsatisfiedTechnicalIssueExplanation =
      unsatisfiedTechnicalIssueExplanation;
  }

  if (unsatisfiedOtherExplanation) {
    explanationsPayload.unsatisfiedOtherExplanation =
      unsatisfiedOtherExplanation;
  }

  return {
    explanationsPayload,
    hasLeftForCompetition: leftForCompetition,
    reasons: Array.from(reasons),
  };
};

export default getFormattedAccountClosureFormValues;
